import router from '../router/index'
const hostname = window.location.hostname ;
let front = '';
let back = '';

if(process.env.VUE_APP_BASE_URL_PROD.includes(hostname)){
  front=process.env.VUE_APP_BASE_URL_PROD
  back=process.env.VUE_APP_API_BASE_PROD+process.env.VUE_APP_API_VERSION
    
  }


if(process.env.VUE_APP_BASE_URL_PREPROD.includes(hostname)){
  front=process.env.VUE_APP_BASE_URL_PREPROD
  back=process.env.VUE_APP_API_BASE_PREPROD+process.env.VUE_APP_API_VERSION
    
  }
  
  if(process.env.VUE_APP_BASE_URL_DEV.includes(hostname)){
    front=process.env.VUE_APP_BASE_URL_DEV
    back=process.env.VUE_APP_API_BASE_DEV+process.env.VUE_APP_API_VERSION
    // alert(window.location)
  }

  if(process.env.VUE_APP_BASE_URL_DEV_LOCAL.includes(hostname)){
    front=process.env.VUE_APP_BASE_URL_DEV_LOCAL
    back=process.env.VUE_APP_API_BASE_DEV_LOCAL+process.env.VUE_APP_API_VERSION
    
  }

  if(process.env.VUE_APP_BASE_URL_SANDBOX.includes(hostname)){
    front=process.env.VUE_APP_BASE_URL_SANDBOX
    back=process.env.VUE_APP_API_BASE_SANDBOX+process.env.VUE_APP_SANDBOX
    
  }


export function formatNumber(str) {
  //console.log('str',str)

  var valueFormatted = '';
  str ? str.toString().includes(',')
    ? valueFormatted = str.toString().replace(/,/g, ' ').replace(/\./g, ',')
    : valueFormatted = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    : valueFormatted = "0";

  return valueFormatted;
}

export function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;

  }
}
export const checkSessionValidate = (goback = 0) => {
  const start = (localStorage.getItem('startingDate') == null) ? 0 : localStorage.getItem('startingDate');
  const now = Date.now();
  let interval = (now - start) / (1000 * 60);
  if (goback == 0) {
    return process.env.VUE_APP_SESSION_TIME >= interval;
  } else {

    if (process.env.VUE_APP_SESSION_TIME >= interval) {
      return true;
    } else {
      logout(back)
    }
  }
}

export const validate_phone_number = (myvalue, tag, len = 10) => {

  var phone = myvalue;
  phone = phone.replace(/\s+/g, '');
  var temp = phone.substring(phone.length - 1, phone.length);
  if (phone.search("[^0-9]") >= 0) {
    if (temp != '' && temp <= 9 && phone.length <= len) {
      // 
    } else {
      if (typeof (temp) === 'string') {
        tag.value = phone.substring(0, phone.length - 1);
      }
      if (phone.substring(0, phone.length - 1).search("[^0-9]") >= 0) {
        tag.value = '';
      }


    }
  }
  if (phone.length > len) {
    tag.value = phone.substring(0, phone.length - 1);
  }
}

export const showToastOld = (message) => {
  const toastElement = document.getElementById("liveToast");
  localStorage.setItem('message', message);
  if (toastElement) {
    toastElement.style.zIndex = 1056;
    const toastBootstrap = new window.bootstrap.Toast(toastElement);
    toastBootstrap.show();
  }
  // localStorage.setItem('message', null);
};

export const showToast = (message, color) => {
  var x = document.getElementById("snackbar");
  x.style.backgroundColor = color;
  x.style.zIndex = "1056";
  x.innerText = message;
  x.className = "show";
  setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
}

export const checkAmount = (jsonArray) => {
  let i = 0;
  for (const row of jsonArray) {
    if (parseFloat(row.amount) <= 0) {
      i++;
    }
  }
  return i;
}

export const getBeneficiaryWithIncorrectAmount = (jsonArray, checkField = "amount") => {
  let i = 0;
  let beneficiaries = [];
  for (const row of jsonArray) {
    if (parseFloat(row[checkField]) <= 0 || checkFormat(row[checkField]) > 0) {
      beneficiaries.push(row);
      i++;
    }

  }
  return [i, beneficiaries];
}

export const checkDuplicateTel = (jsonArray) => {
  let tempJsonArray = jsonArray;
  let totalAmount = 0;
  let duplicateArray = [];
  let i = 0;
  let k = 0;
  for (const row of jsonArray) {
    let tempMobile = row.mobile.trim();
    let j = k + 1;
    while (j < tempJsonArray.length) {
      if (tempMobile == tempJsonArray[j].mobile.trim()) {
        i++;
        totalAmount += parseInt(tempJsonArray[j].amount);
        duplicateArray.push(tempJsonArray[j]);
        tempJsonArray.splice(j, 1);
      }
      j++;
    }
    k++;
  }
  return [i, totalAmount];
}


export const checkDuplicateTelBis = (jsonArray, checkField = "mobile") => {
  let tempJsonArray = jsonArray;
  let duplicateArray = [];
  let i = 0;
  let k = 0;
  for (const row of jsonArray) {
    let tempMobile = row[checkField].trim();
    let j = k + 1;
    while (j < tempJsonArray.length) {
      if (tempMobile == tempJsonArray[j][checkField].trim()) {
        i++;
        duplicateArray.push(tempJsonArray[j]);
        tempJsonArray.splice(j, 1);
      }
      j++;
    }
    k++;
  }
  return i;
}

export const checkDuplicateTelOld = (jsonArray) => {
  let tempJsonArray = jsonArray;
  // tempJsonArray.splice(0, 1);
  let duplicateArray = [];
  let i = 0;
  let k = 0;
  for (const row of jsonArray) {
    let tempMobile = row.mobile.trim();
    let j = k + 1;
    while (j < tempJsonArray.length) {
      if (tempMobile == tempJsonArray[j].mobile.trim()) {
        i++;
        duplicateArray.push(tempJsonArray[j]);
        tempJsonArray.splice(j, 1);
      }
      j++;
    }
    k++;
  }
  return i;
}

export const checkTelSize = (jsonArray, phoneMask, checkField = "mobile") => {

  let i = 0;
  for (const row of jsonArray) {
    // alert(row.mobile.length)
    if (row[checkField].length !== phoneMask) {

      i++;
    }
  }
  return i;
}

export const getBeneficiaryWithIncorrectTelSize = (jsonArray, phoneMask, checkField = "mobile") => {

  let i = 0;
  let beneficiaries = [];
  for (const row of jsonArray) {
    // alert(row.mobile.length)
    if (row[checkField].length !== phoneMask) {
      beneficiaries.push(row);
      i++;
    }
  }
  return [i, beneficiaries];
}

export const checkTelFormat = (jsonArray, checkField = "mobile") => {

  let i = 0;
  for (const row of jsonArray) {
    let mobile = row[checkField].trim().split("");   //
    let j = 0;
    while (j < mobile.length) {
      if (parseInt(mobile[j]) >= 0) {
        //

      } else {
        // alert(mobile[j]);
        i++;
        break;
      }
      j++;
    }
  }
  return i;
}

export const checkFormat = (field) => {
  let i = 0;
  let mobile = field.trim().split("");   //
  let j = 0;
  while (j < mobile.length) {
    if (parseInt(mobile[j]) >= 0) {
      //
    } else {
      i++;
      break;
    }
    j++;
  }
  return i;
}

export const getBeneficiaryWithIncorrectTelFormat = (jsonArray, checkField = "mobile") => {

  let i = 0;
  let beneficiaries = [];
  for (const row of jsonArray) {
    let mobile = row[checkField].trim().split("");   //
    let j = 0;
    while (j < mobile.length) {
      if (parseInt(mobile[j]) >= 0) {
        //

      } else {
        // alert(mobile[j]);
        beneficiaries.push(row);
        i++;
        break;
      }
      j++;
    }
  }
  return [i, beneficiaries];
}

export const checkTelFormatOld = (jsonArray) => {

  let i = 0;
  for (const row of jsonArray) {
    let mobile = row.mobile.trim().split("");   //
    let j = 0;
    while (j < mobile.length) {
      if (parseInt(mobile[j]) >= 0) {
        //

      } else {
        // alert(mobile[j]);
        i++;
        break;
      }
      j++;
    }
  }
  return i;
}



export const getBeneficiaryWithIncorrectTelOperatorName = (jsonArray, operators) => {
  let i = 0;
  let beneficiaries = [];
  for (const row of jsonArray) {
    let temp = operators.filter(operator => operator.mnoName == row.operator);
    if (temp.length == 0) {
      beneficiaries.push(row);
      i++;
    }
  }
  return [i, beneficiaries];
}

export const checkTelOperatorName = (jsonArray, operators) => {
  let i = 0;
  for (const row of jsonArray) {
    let temp = operators.filter(operator => operator.mnoName == row.operator);
    if (temp.length == 0) {
      i++;
    }
  }
  return i;
}

const fnLogout = async (backApi) => {

  if (!backApi) {
    console.warn("Aucune URL API fournie à fnLogout");
    return;
  }

  try {
    const token = localStorage.getItem('login_token');
    const emailValue = localStorage.getItem('email');

    const response = await fetch(`${backApi}/secure/logout`, {
      method: 'POST',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: emailValue }),
    });

    if (!response.ok) {
      const msg = await response.text();

      if (response.status === 401) {
        console.warn("Token expiré ou invalide");
      } else {
        console.error("Erreur backend logout:", msg);
      }
    }

  } catch (error) {
    console.error("Erreur réseau fetch logout:", error);
  }
};




export const logout = async (baseUrl) => {
  if (baseUrl != '') {
      fnLogout(baseUrl)
    }

  try {

  
    localStorage.removeItem('personnal_account_status');
    localStorage.removeItem('account_size');
    localStorage.removeItem('startingDate');
    localStorage.removeItem('login_token');
    localStorage.removeItem('organization_code');
    localStorage.removeItem('organization_name');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('status');
    localStorage.removeItem('role');
    localStorage.removeItem('organizationDonut');
    localStorage.removeItem('organizationChartbyMonth');
    localStorage.removeItem('weekChart');
    localStorage.removeItem('day');
    localStorage.removeItem('weekBalance');
    localStorage.removeItem('dailyBalance')
    router.push('/logout')

  } catch (error) {
    console.error(error);

  }
};

export const strUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

export const img_src = (src) => {
  return new URL("https://" + src)
}

export const wordWrapOld = (str, max, br = '\n') => str.replace(
  new RegExp(`(?![^\\n]{1,${max}}$)([^\\n]{1,${max}})\\s`, 'g'), `$1${br}`
);

export const wordWrap = (str, max, br = '\n') => {
  str = str.replace(new RegExp(`(?![^\\n]{1,${max}}$)([^\\n]{1,${max}})\\s`, 'g'), `$1 ${br} `);
  return str;
}